export default class ModalDialogUtil {
  static openModalDialogBodyFix() {
    document.body.classList.add("modal-open");
    document.body.style = "overflow: hidden;";
  }

  static closeModalDialogBodyFix() {
    //document.body.classList.remove("modal-open");
    document.body.style = "overflow-y: auto !important;";
  }
}
